export default "__VITE_ASSET__7a99a306__"